/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import s from './Layout.css';
import Header from '../Header';
import Footer from '../Footer';
import { setDeepSEAJobs } from '../../actions/DeepSEAActions';
import { DEEPSEA_COOKIE_NAME, HIDE_LATEST_BANNER_COOKIE } from '../../settings';

export const hiddenBannerPaddingTop = 5;
export const visibleBannerPaddingTop = 70;
export const defaultPaddingTop = 30;

interface HeaderOptions {
  showBanner?: boolean;
  showTutorial?: boolean;
  hideLogo?: boolean;
  showSearch?: boolean;
  showAnalysis?: boolean;
  showResources?: boolean;
  showHelp?: boolean;
  helpComponent?: ReactElement | null;
}

interface LayoutProps {
  children: ReactNode;
  headerOptions?: HeaderOptions;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  headerOptions = {
    showBanner: false,
    showTutorial: false,
    hideLogo: false,
    showSearch: false,
    showAnalysis: true,
    showResources: true,
    showHelp: true,
    helpComponent: null,
  },
}) => {
  const [cookie] = useCookies([DEEPSEA_COOKIE_NAME, HIDE_LATEST_BANNER_COOKIE]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setDeepSEAJobs(cookie[DEEPSEA_COOKIE_NAME] || {}));
  }, [dispatch, cookie]);

  return (
    <div
      style={{
        paddingTop:
          cookie[HIDE_LATEST_BANNER_COOKIE] !== 'true'
            ? `${visibleBannerPaddingTop}px`
            : `${hiddenBannerPaddingTop}px`,
      }}
    >
      <Header {...headerOptions} />
      {children}
      <Footer />
    </div>
  );
};

export default withStyles(s)(Layout);
